export const DonetionsListWithPaggination = (state) => {
    console.log('state',state)
    return state?.donetions?.donetions;
};
export const DonetionsIsLoading = (state) => {
    return state?.donetions?.showLoading;
};
